import { readMetadata, saveMetadata } from '../feature-metadata';
import { isExpired } from './isExpired';

/**
 * Удаляет протухшие записи всех пользователей по реестру metadata.registry.
 */
export const cleanupExpiredRecordsByMetadata = (
    metadataKey: string,
    ttlMs: number,
    storage: Storage
) => {
    const metadata = readMetadata(metadataKey, storage);
    let changed = false;

    for (const [envelopeKey, savedAt] of Object.entries(metadata.registry)) {
        if (!isExpired(savedAt, ttlMs)) continue;

        storage.removeItem(envelopeKey);
        delete metadata.registry[envelopeKey];

        changed = true;
    }

    if (changed) {
        saveMetadata(metadataKey, metadata, storage);
    }
};
